import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import islands from '@constants/islands'
import countries from '@constants/countries'

export default class YouthLeader extends React.Component {
  resource = '/certified_youth_leaders'
  form_key = 'certified_youth_leader'
  defaults = {}

  // Delete lines as needed
  fee           = 25
  skip_location = true
  hide_buttons  = false
  custom_actions = []

  validate = null

  foremost = null

  fields = form => [
    {
      name: 'nationality',
    },
    {
      name: 'marital_status',
      options: ['Single', 'Married', 'Divorced', 'Widowed'], 
    },
    {
      name: 'address',
      label: 'Street address',
    },
    {
      name: 'island',
      options: islands,
    },
    {
      name: 'country',
      options: countries,
    },
    {
      name: 'qualifications_list',
      label: 'Qualifications (Degrees, Certifications, Etc.)',
      columns: ['qualification'],
      format: v => v.qualification 
    },
    {
      name: 'experience_list',
      label: 'Experience in Youth/Work Organizations',
      columns: ['organization', 'position'],
      // format: v => [v.organization, v.position]
    },

    '::Organization & Place of Employment',
    {
      name: 'organization_name',
      label: 'Name of organiztion',
    },
    {
      name: 'current_position',
      label: 'Current position held in organization',
    },
    {
      name: 'years_served',
      label: 'Years served in organization',
      is: 'integer'
    },
    {
      name: 'organization_experience',
      label:'Experience in Youth work/Organization & positions Held',
      type: 'textarea',
    },
    {
      name: 'place_of_employment',
    },

    "::Character Reference",
    {
      name: 'character_references_list',
      fields: [
        'first_name',
        'last_name',
        {
          name: 'relationship',
          datalist: ['Parent', 'Relative', 'Friend', 'Colleague', 'Associate', 'Other'],
        },
        {
          name: 'phone_contact',
          label: 'Phone #',
          type: 'phone',
        },
        {
          name: 'organization_name',
          label: 'Organization Name',
          required: false,
        },
        {
          name: 'position_held',
          label: 'Position Held',
          required: false,
        }
      ]
    },

    '::Emergency Contact(s)',
    {
      name: 'emergency_contacts',
      fields: [
        'first_name',
        'last_name',
        {
          name: 'relationship',
          datalist: ['Spouse', 'Parent', 'Son', 'Daughter', 'Relative'],
        },
        {
          name: 'phone_numb',
          label: 'Phone #',
          type: 'phone',
        }
      ]
    },
  
    '::SPACER',
    {
      name: 'photo_upload',
      key: 'image.0',
      type: 'file:image',
      label: 'Self portrait',
    },
  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
